<nav class="navbar navbar-expand-lg bg-white app-navigation-bar">
    <div class="container d-flex justify-content-between">
        <img src="assets/Surgical Science Logo.png" height="50">
        <h3 class="app-title">
            Automatic Updates Console
        </h3>
        <ul class="navbar-nav d-none d-lg-flex ml-2 order-3" *ngIf="isLoggedIn()">
            <li class="nav-item"><a class="nav-link cursor-pointer" (click)="onUser()" role="button"><i class="fa fa-user-circle"></i> {{getLoggedUser().name}}</a></li>
            <li class="nav-item"><a class="nav-link cursor-pointer" (click)="onSignOut()" role="button"><i class="fa fa-sign-out"></i> Logout</a></li>
        </ul>
    </div>
</nav>